


















































































































































































import { mapActions, mapGetters } from "vuex";

import TimelineItem from "@/components/TimelineItem";

import { App, General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import { getCCFormated } from "@/utils/transformers";

import printIcon from "@/assets/svg/print-solid.svg";
import { milisecondsToFormatedTime } from "@/utils/timeUtility";
import { IProcessHistory } from "@/store/types/timeline";

export default {
  name: "SearchViewDetail",

  components: {
    TimelineItem
  },

  props: {
    process: {
      type: Object,
      required: true
    },
    timeLine: {
      type: Array as () => IProcessHistory[],
      default: () => []
    },
    processTime: {
      type: Number,
      default: () => 0
    },
    externalAbbreviation: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      App,
      General,
      printIcon,
      milisecondsToFormatedTime,
      getCCFormated
    };
  },

  computed: {
    ...mapGetters({ isMobile: "isMobile" })
  },

  methods: {
    ...mapActions({ getCompletePublicFile: "getCompletePublicFile" }),

    applyMaskNUP(value: string) {
      return applyMask(NUP, value);
    }
  }
};
